import {makeAutoObservable} from 'mobx';

import {Filter} from '_/utilities';

import {ActiveState} from './ActiveFilter.types';
import {ActiveFilterTranslation} from './ActiveFilter.utils';

export class ActiveFilters {
  public activeFilter = new Filter<ActiveState, true>('ACTIVE');
  public filters = [this.activeFilter];

  public constructor() {
    makeAutoObservable(this, {}, {autoBind: true});
  }

  public get modified(): boolean {
    return this.filters.some((filter) => filter.isModified());
  }

  public get activeFilterText(): string {
    return ActiveFilterTranslation[this.activeFilter.item];
  }
}
